'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _senderTypeMap;

exports.getMappedSenderTypeFromPubnubMessage = getMappedSenderTypeFromPubnubMessage;
exports.getMappedSenderTypeForPubnub = getMappedSenderTypeForPubnub;

var _senderTypes = require('../constants/senderTypes');

var SenderTypes = _interopRequireWildcard(_senderTypes);

var _cmfSenderTypes = require('../../common-message-format/constants/cmfSenderTypes');

var CMFSenderTypes = _interopRequireWildcard(_cmfSenderTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var senderTypeMap = (_senderTypeMap = {}, _defineProperty(_senderTypeMap, SenderTypes.AGENT, CMFSenderTypes.AGENT_SENDER), _defineProperty(_senderTypeMap, SenderTypes.SYSTEM, CMFSenderTypes.SYSTEM_SENDER), _defineProperty(_senderTypeMap, SenderTypes.BOT, CMFSenderTypes.BOT_SENDER), _defineProperty(_senderTypeMap, SenderTypes.VISITOR, CMFSenderTypes.VISITOR_SENDER), _senderTypeMap);

var senderTypeMapInverse = void 0;

function getMappedSenderTypeFromPubnubMessage(senderKey) {
  if (!senderTypeMapInverse) {
    senderTypeMapInverse = Object.keys(senderTypeMap).reduce(function (accum, key) {
      accum[senderTypeMap[key]] = key;
      return accum;
    }, {});
    senderTypeMapInverse[CMFSenderTypes.VID_SENDER] = SenderTypes.VISITOR;
  }

  return senderTypeMapInverse[senderKey];
}

function getMappedSenderTypeForPubnub(senderKey) {
  return senderTypeMap[senderKey];
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/getMappedCommentSenderType.js
// module id = 375
// module chunks = 2 3